import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { getAppRoutes } from 'src/features/landing/store/landing-slice';
import {
  IChildObj,
  IRouteMetadata
} from 'src/components/layout/appDrawer/types/auth-response.model';
import { getSideNavBarData } from './app-drawer-slice-async-thunk';

export interface IAppDrawerNav extends IRouteMetadata {
  isOpen: boolean;
}

export interface IAppDrawerState {
  navOptions: any[];
  isFetchingOptions: boolean;
  isDrawerOpen: boolean;
}

const initialState: IAppDrawerState = {
  navOptions: [],
  isFetchingOptions: false,
  isDrawerOpen: false
};

const appDrawerSlice = createSlice({
  name: 'app-drawer',
  initialState,
  reducers: {
    toggleListState: (state, action: PayloadAction<IAppDrawerNav>) => {
      state.navOptions.forEach((navOption) => {
        // eslint-disable-next-line no-param-reassign
        navOption.isOpen = false;
      });
      const index = state.navOptions.findIndex(
        // eslint-disable-next-line dot-notation
        (navOption) => navOption.parent.name === action.payload['parent'].name
      );
      // adding check for children length such that lead node should not get expanded
      if (index > -1 && action.payload.children.length) {
        state.navOptions[index].isOpen = !action.payload.isOpen;
      }
    },
    setIsDrawerOpen(state, action: PayloadAction<boolean>) {
      state.isDrawerOpen = action.payload;
    },
    // reducer for updating pages data on favorite click
    setFavoriteStatusForPages(state, action) {
      const { pageName, isFavoriteValue } = action.payload as {
        pageName: IChildObj;
        isFavoriteValue: number | boolean;
      };
      let clonedNavOptions = JSON.parse(JSON.stringify(state.navOptions));

      // TODO: logic with for loop
      // for (let i = 0; i < clonedNavOptions.length; i++) {
      //   let currChildrens = clonedNavOptions[i].children;
      //   if (currChildrens.length > 0)
      //     for (let j = 0; j < currChildrens.length; j++) {
      //       if (currChildrens[j].parent.name === pageName) {
      //         // Update the isFavourite property
      //         clonedNavOptions[i].children[j].parent.is_favourite =
      //           isFavoriteValue;
      //         break;
      //       }
      //     }
      // }

      // handler for updating is_favourite property for respective page
      const updatedNavOptions = clonedNavOptions.map((e) => {
        // Check if children exist before mapping
        const updatedChildren = e.children.map((childitem) => {
          // Update the is_favourite property if the condition is true
          if (childitem.parent.name === pageName) {
            return {
              ...childitem,
              parent: {
                ...childitem.parent,
                is_favourite: isFavoriteValue // Setting is_favourite to the new value
              }
            };
          }
          // Return the child unchanged if the condition is false
          return childitem;
        });

        // Return the updated object with the updated children array
        return {
          ...e,
          children: updatedChildren // Updated children array
        };
      });
      state.navOptions = updatedNavOptions;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getSideNavBarData.pending, (state) => {
        state.isFetchingOptions = true;
      })
      .addCase(getSideNavBarData.rejected, (state) => {
        state.isFetchingOptions = false;
      })
      .addCase(getSideNavBarData.fulfilled, (state, action) => {
        state.isFetchingOptions = false;
        state.navOptions = action.payload.map((payload) => ({
          ...payload,
          isOpen: false
        }));
        if (state.navOptions.length) {
          state.navOptions[0].isOpen = true;
        }
      })
});

export const { toggleListState, setIsDrawerOpen, setFavoriteStatusForPages } =
  appDrawerSlice.actions;

export default appDrawerSlice;
